import { Navigate } from 'react-router-dom';

import { Flow_Types } from '@occc-app/offerHelpers/types';

import { OfferConfigurePage } from './OfferConfigurePage';
import { OfferConfigurePageContainerProps } from './types';

import { useGetContainerProps } from '../hooks/useGetContainerProps';

export const OfferConfigurePageContainer = (props: OfferConfigurePageContainerProps) => {
  const {
    campaignId,
    offerId,
    offerType,
    pageTitle,
    subtitle,
    ConfigureFormContainer,
    isDesignTabHidden = false,
    targetTabProps,
    getBreadcrumbLinks,
    ignoreConfigureFormSubmit = false,
    showExternalUrl = false,
    showSurgeonGeneralsWarning = true,
    getIsOrderAheadEnabled,
    redirects,
  } = props;

  const { layoutProps, initialFormProps, scheduleFormProps, formContainersProps, dialogProps } =
    useGetContainerProps({
      campaignId,
      offerId,
      offerType,
      flowType: Flow_Types.Configure,
      getBreadcrumbLinks,
      ignoreConfigureFormSubmit,
      getIsOrderAheadEnabled,
    });

  const redirectRequired = redirects?.find(({ when }) =>
    when({ offer: formContainersProps.offer }),
  );
  if (redirectRequired) {
    return <Navigate to={redirectRequired.to} replace />;
  }

  return (
    <OfferConfigurePage
      layoutProps={layoutProps}
      formContainersProps={formContainersProps}
      dialogProps={dialogProps}
      initialFormProps={initialFormProps}
      scheduleFormProps={scheduleFormProps}
      configureForm={
        ConfigureFormContainer ? <ConfigureFormContainer {...formContainersProps} /> : undefined
      }
      isDesignTabHidden={isDesignTabHidden}
      targetTabProps={targetTabProps}
      pageTitle={pageTitle}
      subtitle={subtitle}
      showExternalUrl={showExternalUrl}
      showSurgeonGeneralsWarning={showSurgeonGeneralsWarning}
    />
  );
};
